import React from 'react';
import {useHistory} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import TableLink from "v4/components/utils/TableLink/TableLink";
import PdfButton from "v4/features/front/generatePdf/components/PdfButton/PdfButton";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import useListingRowActionsRoute from "v4/hooks/useListingRowActionsRoute";
import {getQuotePdfFiles} from "v4/utils/quotePdfFiles";

export default function QuotesListingRowActions({ rowId, prospectId, isWon, files, name }) {
    const {replace} = useHistory();
    const route = useListingRowActionsRoute([
        { identifier: 'detail_won_quotes', condition: isWon },
        { identifier: 'detail_quotes', condition: true }
    ]);

    const refreshListing = () => replace({state: {hasToRefresh: true}});

    return (
        <>
            <TableLink href={`/${resolveUrl(route.url, { prospect: prospectId })}/${rowId}`}/>
            <ul className="table-actions">
                <li className={`table-actions__pdf ${getQuotePdfFiles(files).length > 0 ? 'has-dropdown' : ''}`}>
                    <PdfButton variant="listing"
                               files={files}
                               quoteId={rowId}
                               quoteName={name}
                               updateHandler={refreshListing}/>
                </li>
            </ul>
            <ReactTooltip id="row-action" effect="solid"/>
        </>
    )
}
